import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { STATUS } from '../../utils/status';
import { Link } from 'react-router-dom';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { deleteCommunication, updateCommunication, fetchCommunication } from '../../redux/iletisimSlice';

const IletisimList = ({ title }) => {
    const dispatch = useDispatch();
    const [editingIletisim, setEditingIletisim] = useState(null);
    const [editedIletisim, setEditedIletisim] = useState({});

    const { iletisimdata, iletisimstatus, iletisimerror } = useSelector((state) => state.communication);
    useEffect(() => {
        if (iletisimstatus === STATUS.IDLE) {
            dispatch(fetchCommunication());
        }
    }, [iletisimstatus, dispatch]);

    const handleDelete = (id) => {
        dispatch(deleteCommunication(id));
    };

    const handleUpdate = (id) => {
        dispatch(updateCommunication({ id, updatedData: editedIletisim }));
        setEditingIletisim(null);
        setEditedIletisim({});
    };

    const handleEdit = (user) => {
        setEditingIletisim(user.id);
        setEditedIletisim(user);
    };

    const handleCancel = () => {
        setEditingIletisim(null);
        setEditedIletisim({});
    };
    return (
        <>
            <div className="listTitle">{title}</div>
            <Link to="/new-iletisim" className="mb-2 inline-block">
                <button className="btn btn-primary">New Iletisim</button>
            </Link>
            <TableContainer component={Paper} className="table">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className="tableCell">ID</TableCell>
                            <TableCell className="tableCell">Image</TableCell>
                            <TableCell className="tableCell">Firma Adı</TableCell>
                            <TableCell className="tableCell">Telefon</TableCell>
                            <TableCell className="tableCell">Email</TableCell>
                            <TableCell className="tableCell">Adres</TableCell>
                            <TableCell className="tableCell">Ayarlar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {iletisimstatus === STATUS.LOADING && (
                            <TableRow>
                                <TableCell colSpan={9} className="tableCell">Loading...</TableCell>
                            </TableRow>
                        )}
                        {iletisimstatus === STATUS.FAIL && (
                            <TableRow>
                                <TableCell colSpan={9} className="tableCell">Error: {iletisimerror}</TableCell>
                            </TableRow>
                        )}
                        {iletisimstatus === STATUS.SUCCESS && iletisimdata.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell className="tableCell">{row.id}</TableCell>
                                <TableCell className="tableCell">
                                    {editingIletisim === row.id ? (
                                        <input
                                            type="text"
                                            value={editedIletisim.images[0].url}
                                            onChange={(e) => setEditedIletisim({ ...editedIletisim, images: e.target.value })}
                                            placeholder="Edit Images"
                                            className="border p-1 rounded"
                                        />
                                    ) : (
                                        <div className="flex items-center">
                                            <img src={row?.images[0].url} alt="" className="w-10 h-10 rounded-full mr-1 object-cover" />
                                        </div>
                                    )}
                                </TableCell>
                                <TableCell className="tableCell">
                                    {editingIletisim === row.id ? (
                                        <input
                                            type="text"
                                            value={editedIletisim.firmaadi}
                                            onChange={(e) => setEditedIletisim({ ...editedIletisim, firmaadi: e.target.value })}
                                            placeholder="Edit Firma Adı"
                                            className="border p-1 rounded"
                                        />
                                    ) : (
                                        row.firmaadi
                                    )}
                                </TableCell>
                                <TableCell className="tableCell">
                                    {editingIletisim === row.id ? (
                                        <input
                                            type="text"
                                            value={editedIletisim.telefon}
                                            onChange={(e) => setEditedIletisim({ ...editedIletisim, telefon: e.target.value })}
                                            placeholder="Edit Telefon"
                                            className="border p-1 rounded"
                                        />
                                    ) : (
                                        row.telefon
                                    )}
                                </TableCell>
                                <TableCell className="tableCell">
                                    {editingIletisim === row.id ? (
                                        <input
                                            type="text"
                                            value={editedIletisim.email}
                                            onChange={(e) => setEditedIletisim({ ...editedIletisim, email: e.target.value })}
                                            placeholder="Edit Email"
                                            className="border p-1 rounded"
                                        />
                                    ) : (
                                        row.email
                                    )}
                                </TableCell>
                                <TableCell className="tableCell">
                                    {editingIletisim === row.id ? (
                                        <input
                                            type="text"
                                            value={editedIletisim.adres}
                                            onChange={(e) => setEditedIletisim({ ...editedIletisim, adres: e.target.value })}
                                            placeholder="Edit Adres"
                                            className="border p-1 rounded"
                                        />
                                    ) : (
                                        row.adres
                                    )}
                                </TableCell>
                                <TableCell className="tableCell">
                                    <div className="flex items-center gap-3">
                                        <div
                                            className="deleteButton p-1 border border-dotted border-red-600 text-red-600 cursor-pointer rounded"
                                            onClick={() => handleDelete(row.id)}
                                        >
                                            Delete
                                        </div>
                                        {editingIletisim === row.id ? (
                                            <>
                                                <div className="viewButton p-1 border border-dotted border-blue-600 text-blue-600 cursor-pointer rounded" onClick={() => handleUpdate(row.id)}>Save</div>
                                                <div className="viewButton p-1 border border-dotted border-pink-600 text-pink-600 cursor-pointer rounded" onClick={handleCancel}>Cancel</div>
                                            </>
                                        ) : (
                                            <div className="viewButton p-1 border border-dotted border-blue-600 text-blue-600 cursor-pointer rounded" onClick={() => handleEdit(row)}>Edit</div>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default IletisimList
